import type { CreatureSpiritSyncInput, CreatureSpiritSyncResult } from '../types';

const finite = (value: number | null): number => value !== null && Number.isFinite(value) ? value : 0;

/** Plan the finalizer's encounter Spirit synchronization without performing its database write. */
export function compileCreatureSpiritSync(input: CreatureSpiritSyncInput): CreatureSpiritSyncResult {
    const shouldSync = input.hasEncounterCreatureId
        && input.hasComputedSpirit
        && input.hasStoredSpirit
        && finite(input.storedSpirit) !== finite(input.computedSpirit);
    if (!shouldSync) {
        return { shouldSync: false, spirit: input.hasStoredSpirit ? input.storedSpirit : null, manaPercent: input.manaPercent, writeUpdates: null };
    }
    const spirit = finite(input.computedSpirit);
    const manaPercent = spirit !== 0 ? Math.floor((finite(input.mana) / spirit) * 100) : 0;
    return { shouldSync: true, spirit, manaPercent, writeUpdates: { spirit } };
}
